import { recordPath, recordRoute } from '@/shared/registry'

/** Where the issued badge pages live. */
export const issuedBadgesPath = '/credentials/issued-badges'
export const issuedBadgeRoute = recordRoute('credentials', 'issued-badges')

/** An issued badge's details page. */
export function issuedBadgePath(id: string): string {
  return recordPath('credentials', 'issued-badges', id)
}

/** Issue Badges, for a class's public id. */
export const issueBadgesRoute = '/credentials/classes/:classId/issue-badges'

export function issueBadgesPath(classId: string): string {
  return `/credentials/classes/${encodeURIComponent(classId)}/issue-badges`
}

/** The base of Issued Badge Details' slots (`detailsSlots`). */
export const issuedBadgeDetailsSlot = 'credentials.issued-badge-details'

/** The permissions the issued badge screens show or hide their actions by. */
export const readIssuedBadgesPermission = 'credentials.issued-badges.read'
export const writeIssuedBadgesPermission = 'credentials.issued-badges.write'
export const deleteIssuedBadgesPermission = 'credentials.issued-badges.delete'

/** The API's issued badge endpoints. */
export const issuedBadgesApi = '/credentials/v1/issued-badges'

export function issuedBadgeApi(id: string): string {
  return `${issuedBadgesApi}/${encodeURIComponent(id)}`
}

/** What Issue Badges offers for a class. */
export function badgeIssuingApi(classId: string): string {
  return `/credentials/v1/classes/${encodeURIComponent(classId)}/badge-issuing`
}
